// Keep the policy help and cover notice aligned when the provider loads or copy reflows.
for (const root of document.querySelectorAll('[data-gold-cover]')) {
  const desktop = matchMedia('(min-width: 1024px)');
  const help = root.querySelector('.gold-cover__help');
  const primary = root.querySelector('.coffee-product__primary');
  if (!help || !primary) continue;

  let frame = 0;
  let observedNotice;
  const align = () => {
    frame = 0;
    root.style.removeProperty('--gold-cover-help-offset');
    root.style.removeProperty('--gold-cover-notice-offset');
    root.style.removeProperty('--gold-cover-alignment-clearance');
    const notice = root.querySelector('.gold-cover__notice');
    if (notice !== observedNotice) {
      if (observedNotice) resize.unobserve(observedNotice);
      if (notice) resize.observe(notice);
      observedNotice = notice;
    }
    if (!desktop.matches || !notice || !notice.getClientRects().length) return;
    const difference = help.getBoundingClientRect().top - notice.getBoundingClientRect().top;
    const property = difference > 0 ? '--gold-cover-notice-offset' : '--gold-cover-help-offset';
    if (Math.abs(difference) >= 1) root.style.setProperty(property, `${Math.abs(difference)}px`);
    const overflow = Math.max(help.getBoundingClientRect().bottom, notice.getBoundingClientRect().bottom) - primary.getBoundingClientRect().bottom;
    if (overflow > 0) root.style.setProperty('--gold-cover-alignment-clearance', `${overflow}px`);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(align);
  };
  const resize = new ResizeObserver(schedule);
  resize.observe(primary);
  resize.observe(help);
  const info = root.querySelector('.coffee-product__info');
  if (info) resize.observe(info);
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  desktop.addEventListener('change', schedule);
  document.fonts.ready.then(schedule);
  schedule();
}
